<template>
	<page>
		<module enable-flex>
			<m-search ref="search" @search="searchHandle">
				<m-search-item label="账号">
					<c-input name="user_name"></c-input>
				</m-search-item>
				<m-search-item label="姓名">
					<c-input name="user_realname"></c-input>
				</m-search-item>
				<m-search-item label="手机号码">
					<c-input name="phone"></c-input>
				</m-search-item>
			</m-search>

			<m-operate>
				<c-button color="main" v-if="auth('b_manage_user_edit')" prepend-icon="tf-add" @click="$refs.sysuserEdit.open()">创建用户</c-button>
			</m-operate>

			<c-table ref="list" height="grow" :paging="false">
				<c-table-column
					type="selector"
					width="32"
				></c-table-column>

				<c-table-column
					label="账号"
					name="user_name"
					width="100"
                    fixed="left"
                >
				</c-table-column>

				<c-table-column
					label="姓名"
					name="user_realname"
					width="100"
				>
				</c-table-column>

				<c-table-column
					label="手机号码"
					name="phone"
					width="120"
				></c-table-column>

				<c-table-column
					label="创建人"
					name="create_user_realname"
					width="80"
				>
				</c-table-column>

				<c-table-column
					label="创建时间"
					name="create_date"
					width="130"
				></c-table-column>

				<!-- 是否启用 -->
				<c-table-column
					label="状态"
					name="state"
					width="80"
                    fixed="right"
                >
					<template #default="{data}">
						<c-switch v-if="auth('b_manage_user_edit') && data.is_manage != 1 " v-model="data.state" :state-value="[1, 2]" :state-text="['启用','禁用']" @beforeChange="stateHandle(arguments[0], arguments[1], data)"></c-switch>
						<c-state v-else dict="disableEnableDic" :value="data.state"></c-state>
					</template>
				</c-table-column>

				<c-table-column
					type="button"
					label="操作"
					width="220"
					button-limit="6"
				>
					<template #default="{data}">
						<c-table-button v-if="auth('b_manage_user_edit')" icon="tf-reset-password" @click="resetPwd(data)">重置密码</c-table-button>
						<c-table-button v-if="auth('b_manage_user_edit')" icon="tf-edit" @click="$refs.sysuserEdit.open(data)">编辑</c-table-button>
						<c-table-button v-if="auth('b_manage_user_edit') && data.is_manage != 1" icon="tf-edit" @click="$refs.userAuthConfig.open(data)">编辑操作权限</c-table-button>
                        <c-table-button v-if="auth('b_manage_user_edit') && data.is_manage != 1 && data.user_type == 1" icon="tf-copy" @click="$refs.userAuthCopy.open(data)">复制操作权限</c-table-button>
                    </template>
				</c-table-column>
			</c-table>
            <!--编辑用户信息弹窗-->
            <sysuser-edit ref="sysuserEdit" @resolve="$refs.list.update()"></sysuser-edit>
            <!--编辑用户菜单权限弹窗-->
            <user-auth-config ref="userAuthConfig" @resolve="$refs.list.update()"></user-auth-config>
            <!--复制用户菜单权限弹窗-->
            <user-auth-copy ref="userAuthCopy" @resolve="$refs.list.update()"></user-auth-copy>
		</module>
	</page>
</template>

<script>
	import {mapState} from 'vuex'
	import sysuserEdit from "@/pages/system/sysuser_edit.vue";
    import userAuthConfig from "@/pages/system/user_auth_config.vue";
    import userAuthCopy from "@/pages/system/user_auth_copy.vue";

    export default {
		components: {
          sysuserEdit,userAuthConfig,userAuthCopy
        },

		computed: {
			// 获取dictName选项数据
			...mapState(['disableEnableDic']),
		},

		data() {
			return {
				view_id:27,
				workType:27,
				flterParams:{} //筛选参数
			}
		},

		mounted() {
			this.searchHandle();
		},

		methods: {
			/********搜索************/
			searchHandle(data){
				if (!data){
					data = {};
				}
				this.$refs.list.load({
					url: '/manage/user/list',
					data
				});
			},

			/******删除用户***********/
			removeSysuser(data){
				this.$confirm({
					message:'确认删除用户【'+data.user_realname+'】？删除后不可恢复',  // 提示内容,
					buttonName: '确定',  // 确定按钮文字
					cancelButton: true,  // 是否显示取消按钮
					resolve: () => {
						this.request({
							url: '/manage/user/delete',
							data: {id:data.id},
							loading: true,
							success: data => {
								this.$message({
									message:'删除成功',  // 提示内容,
									type: 'success'
								});
								this.$refs.list.update();
							}
						});
					},  // 确定按钮回调
					cancel: () => {},  // 取消按钮回调
				});
			},

			/******重置密码***********/
			resetPwd(data){
				this.$confirm({
					message:'确定重置用户【'+data.user_realname+'】的登录密码？',  // 提示内容,
					buttonName: '确定',  // 确定按钮文字
					cancelButton: true,  // 是否显示取消按钮
					resolve: () => {
						this.request({
							url: '/manage/user/reset_pwd',
							data: {id:data.id},
							loading: true,
							success: result => {
								this.$confirm({
									message: result,
									buttonName: '知道了',
									cancelButton: false,
									resolve: () => {
									}
								});
							}
						});
					},  // 确定按钮回调
					cancel: () => {},  // 取消按钮回调
				});
			},

			/******用户启禁用*********/
			stateHandle(state, next, data) {
				this.request({
					url: '/manage/user/update_state',
					data: {
						id: data.id,
						state: state ? 2 : 1
					},
					success: () => {
						next();
					}
				})
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>